import { ButtonBase, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import {
	type ChartTimeFrameKey,
	ChartTimeFrames,
} from "web_myplann/Utils/types";

type Props = {
	value: ChartTimeFrameKey;
	onChange: (value: ChartTimeFrameKey) => void;
};

export const ChartTimeFrameTabs: FC<Props> = ({ value, onChange }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			justifyContent="center"
			alignItems="center"
			gap={theme.spacingTokens.xs}
			py={1}
		>
			{Object.entries(ChartTimeFrames).map(([key, label]) => {
				const frame = Number(key) as ChartTimeFrameKey;
				const isActive = value === frame;
				return (
					<ButtonBase
						key={key}
						onClick={() => onChange(frame)}
						aria-pressed={isActive}
						sx={{
							px: theme.spacingTokens.md,
							py: theme.spacingTokens.xs,
							borderRadius: theme.radii.full,
							fontSize: theme.typography.caption.fontSize,
							fontWeight: theme.typography.button.fontWeight,
							bgcolor: isActive ? theme.palette.blue[500] : "transparent",
							color: isActive
								? theme.palette.common.white
								: theme.palette.grey[500],
							transition: "background-color 200ms, color 200ms",
						}}
					>
						{t(label)}
					</ButtonBase>
				);
			})}
		</Stack>
	);
};
